import { Mapper } from "../../../../../lib/utils/mapper";
import { ConversationRemoteDataSource } from "../../datasources/conversations/conversation-remote.datasource";
import type { IConversationRemoteDataSource } from "../../datasources/conversations/conversation-remote.datasource.interface";
import type { SessionDto } from "../../dtos/session.dto";
import type { IChatbotMessage } from "../../entities/chatbot-message.entity";
import { ChatbotMessage } from "../../entities/chatbot-message.entity";
import type { IConversation } from "../../entities/conversation.entity";
import { Conversation } from "../../entities/conversation.entity";
import type { FeedbackEnum } from "../../enums/feedback.enum";
import type { NegativeFeedbackReasonEnum } from "../../enums/negative-feedback-reason.enum";
import type { IConversationRepository } from "./conversation.repository.interface";

export class ConversationRepository implements IConversationRepository {
  constructor(private readonly _remoteDataSource: IConversationRemoteDataSource = new ConversationRemoteDataSource()) {}
  public createNewSession(): Promise<SessionDto> {
    return this._remoteDataSource.createNewSession();
  }

  public getLastSession(): Promise<SessionDto | void> {
    return this._remoteDataSource.getLastSession();
  }

  public async getAllMessagesForSession(sessionId: string): Promise<IChatbotMessage[]> {
    const sessionMessages = await this._remoteDataSource.getAllMessagesForSession(sessionId);

    return Mapper.mapArrayData(ChatbotMessage, sessionMessages);
  }

  public async getAllConversations(): Promise<IConversation[]> {
    const conversations = await this._remoteDataSource.getAllConversations();
    return Mapper.mapArrayData(Conversation, conversations);
  }

  public async cloneFromPreviousChat(): Promise<SessionDto> {
    return this._remoteDataSource.cloneFromPreviousChat();
  }

  public async updateMessageFeedback(messageId: number, feedback: FeedbackEnum | null): Promise<IChatbotMessage> {
    const messageDto = await this._remoteDataSource.updateMessageFeedback(messageId, feedback);

    const message = Mapper.mapData(ChatbotMessage, messageDto);
    return message;
  }

  public async updateMessageNegativeFeedbackReason(
    messageId: number,
    negativeFeedbackReason: NegativeFeedbackReasonEnum
  ): Promise<IChatbotMessage> {
    const messageDto = await this._remoteDataSource.updateNegativeFeedbackReason(messageId, negativeFeedbackReason);

    const message = Mapper.mapData(ChatbotMessage, messageDto);
    return message;
  }
}
